const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/agentic-insights/experimental/briefing-3.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { experimentalSearchSchema } from '@/features/agentic-insights/components/experimental/briefing-3/data/searchState';
import { agenticInsightsBeforeLoad } from '../index';

/**
 * Briefing #3 — frozen once Briefing #4 (NEX-18040) took over as the default. The permission check
 * and flag gate are reused from the classic route: that is routing plumbing rather than UI, and two
 * copies would drift apart.
 *
 * Its search schema is the variant's own: this one addresses a reading, an objective filter and an
 * open judgment as well as a run, and another variant is free to address something else.
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/experimental/briefing-3')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: agenticInsightsBeforeLoad,
  validateSearch: search => experimentalSearchSchema.parse(search),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.agenticInsights.title)
    }
  }
});